import { Avatar, Popover, Tooltip } from '@infl-ts/ui-advocate-components';
import { Close as CloseIcon, Menu as MenuIcon } from '@mui/icons-material';
import { IconButton, useMediaQuery } from '@mui/material';
import * as RA from 'fp-ts/ReadonlyArray';
import { useTranslation } from 'react-i18next';
import AccountMenu from './account-menu';
import MobileAccountMenu from './mobile-account-menu';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MobileActionBarPopover = function MobileActionBarPopover(_ref) {
  var onOpen = _ref.onOpen,
      links = _ref.links,
      profile = _ref.profile,
      signinEnabled = _ref.signinEnabled,
      signupEnabled = _ref.signupEnabled,
      privacyPolicyLink = _ref.privacyPolicyLink,
      termsAndConditionsLink = _ref.termsAndConditionsLink,
      memberMessagingEnabled = _ref.memberMessagingEnabled,
      navLangSelectorEnabled = _ref.navLangSelectorEnabled,
      actionBarLangSelectorEnabled = _ref.actionBarLangSelectorEnabled;
  var isDesktop = useMediaQuery(function (theme) {
    return theme.breakpoints.up('lg');
  });
  if (!profile && RA.isEmpty(links) && isDesktop) return null;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Popover, {
    noPadding: true,
    zIndex: function zIndex(t) {
      return t.zIndex.aboveStickyBlock;
    },
    sx: {
      mr: 0
    },
    noBoxShadow: true,
    onOpen: onOpen,
    content: function content(popoverOff, isOpen) {
      return /*#__PURE__*/_jsx(MobileAccountMenu, {
        isPopoverOpen: isOpen,
        isDesktop: false,
        profile: profile,
        links: links,
        memberMessagingEnabled: memberMessagingEnabled,
        handlePopoverClose: popoverOff,
        signinEnabled: signinEnabled,
        signupEnabled: signupEnabled,
        privacyPolicyLink: privacyPolicyLink,
        termsAndConditionsLink: termsAndConditionsLink,
        actionBarLangSelectorEnabled: actionBarLangSelectorEnabled,
        navLangSelectorEnabled: navLangSelectorEnabled
      });
    },
    "data-element": "Popover",
    "data-component": "MobileActionBarPopover",
    "data-source-file": "action-bar-popover.tsx",
    children: function children(_ref2) {
      var isOpen = _ref2.isOpen;
      return /*#__PURE__*/_jsx(Tooltip, {
        title: isOpen ? t('Close menu') : t('Open menu'),
        children: /*#__PURE__*/_jsxs(IconButton, {
          sx: {
            ml: 2
          },
          "aria-label": "menu dropdown for navigation",
          "aria-haspopup": "true",
          children: [profile ? /*#__PURE__*/_jsx(Avatar, {
            member: profile,
            disabledPopover: true
          }) : null, isOpen ? /*#__PURE__*/_jsx(CloseIcon, {
            fontSize: "small"
          }) : /*#__PURE__*/_jsx(MenuIcon, {
            fontSize: "small"
          })]
        })
      });
    }
  });
};
export var DesktopActionBarPopover = function DesktopActionBarPopover(_ref3) {
  var onOpen = _ref3.onOpen,
      profile = _ref3.profile,
      privacyPolicyLink = _ref3.privacyPolicyLink,
      termsAndConditionsLink = _ref3.termsAndConditionsLink,
      memberMessagingEnabled = _ref3.memberMessagingEnabled,
      actionBarLangSelectorEnabled = _ref3.actionBarLangSelectorEnabled;
  if (!profile) return null;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_jsx(Popover, {
    noPadding: true,
    zIndex: function zIndex(t) {
      return t.zIndex.aboveStickyBlock;
    },
    sx: {
      mr: 4
    },
    onOpen: onOpen,
    clickAwayMouseEvent: "onMouseUp",
    preventFallback: true,
    content: function content(popoverOff) {
      return /*#__PURE__*/_jsx(AccountMenu, {
        isDesktop: true,
        profile: profile,
        handlePopoverClose: popoverOff,
        privacyPolicyLink: privacyPolicyLink,
        termsAndConditionsLink: termsAndConditionsLink,
        memberMessagingEnabled: memberMessagingEnabled,
        actionBarLangSelectorEnabled: actionBarLangSelectorEnabled
      });
    },
    "data-element": "Popover",
    "data-component": "DesktopActionBarPopover",
    "data-source-file": "action-bar-popover.tsx",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: t('Your profile'),
      "data-element": "Tooltip",
      "data-component": "DesktopActionBarPopover",
      "data-source-file": "action-bar-popover.tsx",
      children: /*#__PURE__*/_jsx(IconButton, {
        "aria-label": "account of current member",
        "aria-haspopup": "true",
        "data-element": "IconButton",
        "data-component": "DesktopActionBarPopover",
        "data-source-file": "action-bar-popover.tsx",
        children: /*#__PURE__*/_jsx(Avatar, {
          member: profile,
          disabledPopover: true,
          "data-element": "Avatar",
          "data-component": "DesktopActionBarPopover",
          "data-source-file": "action-bar-popover.tsx"
        })
      })
    })
  });
};